/**
 * Created by hernanherreros on 2019-05-06
 */
import * as React from 'react'
import { RouterItem } from '../../../config/router.config'
import { Trans } from '@lingui/macro'
import Information from '../containers/Wizard/Information'
import Payment from '../containers/Wizard/Payment'
import Success from '../containers/Wizard/Success'


export const chile2024Steps = ['information', 'payment', 'success']

export const chile2024FormRouterConfig: RouterItem[] = [
  {
    path: '/:congressSlug/wizard/:token/information',
    slug: 'information',
    label: <Trans>Información</Trans>,
    help: <Trans>información</Trans>,
    number: 1,
    component: Information,
  },
  {
    path: '/:congressSlug/wizard/:token/payment',
    slug: 'payment',
    label: <Trans>Pagos</Trans>,
    help: <Trans>Pagos</Trans>,
    number: 2,
    nextButtonLabel: 'Continuar con el registro',
    component: Payment,
  },
  {
    path: '/:congressSlug/wizard/:token/success',
    slug: 'success',
    label: <Trans>¡Último paso!</Trans>,
    help: <Trans>¡Último paso!</Trans>,
    nextButtonLabel: <Trans>Finalizar Registro</Trans>,
    number: 3,
    component: Success,
  },
]
